module.exports = __webpack_public_path__ + "static/media/casino.602be27d.svg";